export default "__VITE_ASSET__SyEDbKtA__"